import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { type Story } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { initialValuesStory, validationSchemaStory } from "./StoryCommon"
import StoryForm from "./StoryForm"
import { useCreateStory } from "../../hooks/stories"

export default function StoryCreate() {
  const createStory = useCreateStory()
  const navigate = useNavigate()

  const initialValues = useMemo(() => initialValuesStory(), [])
  const validationSchema = useMemo(() => validationSchemaStory(), [])

  useBreadcrumbs([{ label: "Storie", href: "/stories/stories" }, { label: "Nuova storia" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova storia</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return createStory.mutateAsync(values as Story).then((story) => {
                navigate(`/stories/stories/${story.id}`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <StoryForm />
                </Container>
                <BottomFormFixed url="/stories/stories" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
